/**
 * Định dạng **khoá ngày** của YouTube (`YYYY-MM-DD`) sang cách viết của app.
 *
 * Khoá ngày là ngày theo giờ Thái Bình Dương mà YouTube Analytics trả về, lưu
 * nguyên chuỗi (xem CLAUDE.md). Vì vậy **không** được đưa qua `new Date()` rồi
 * đổi múi giờ: `2026-09-10` phải hiện `10/09`, không phải `09/09` hay `09/10`.
 *
 * Các hàm trong `apps/web/src/ui/dinhDang.ts` nhận `Date`/ISO có giờ và quy về
 * giờ Việt Nam — dùng cho `createdAt`, `publishAt`… còn khoá ngày thì dùng ở
 * đây.
 */
const KHOA_NGAY = /^(\d{4})-(\d{2})-(\d{2})$/;
const KHOA_THANG = /^(\d{4})-(\d{2})$/;
/** `2026-09-10` → `10/09`. Chuỗi không đúng dạng thì trả nguyên văn. */
export function ngayGonVn(khoa) {
    const m = KHOA_NGAY.exec(khoa);
    return m ? `${m[3]}/${m[2]}` : khoa;
}
/** `2026-09-10` → `10/09/2026`. */
export function ngayDayVn(khoa) {
    const m = KHOA_NGAY.exec(khoa);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : khoa;
}
/** `2026-09` → `09/2026`. */
export function thangVn(ky) {
    const m = KHOA_THANG.exec(ky);
    return m ? `${m[2]}/${m[1]}` : ky;
}
/**
 * Khoảng ngày: `10/09 – 07/10/2026`.
 *
 * Năm chỉ viết một lần ở cuối khi hai đầu cùng năm; khác năm thì viết đủ hai
 * bên (`25/12/2025 – 07/01/2026`).
 */
export function khoangNgayVn(tu, den) {
    if (tu === '' || den === '')
        return '';
    const a = KHOA_NGAY.exec(tu);
    const b = KHOA_NGAY.exec(den);
    if (!a || !b)
        return `${tu} – ${den}`;
    return a[1] === b[1]
        ? `${ngayGonVn(tu)} – ${ngayDayVn(den)}`
        : `${ngayDayVn(tu)} – ${ngayDayVn(den)}`;
}
//# sourceMappingURL=ngay.js.map